import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Modal } from 'react-bootstrap';
import CollapsibleTable from '../common/ExpandCollapseTableList';
import BatchPagination from '../batch/BatchPagination';
import { useDispatch } from 'react-redux';
import { getReconciliationTransactionDetails } from '../../store/actions/carrierReconciliationReport.action';
import { numOfPage, ReconciliationDisputedTransactionDetailsColumns } from '../../constant';
import { toast } from 'react-toastify';
import { formatNumberWithCommas, getFirstAndLastDate } from '../../config/utils';
import LoaderSpinner from '../common/Loader';
import moment from 'moment';
/* istanbul ignore next */
const DisputedTransactions = (props) => {
    const { show, handleCancel, reportDetails, periodDetail } = props;
    console.log("reportDetails", reportDetails);
    const [showLoader, setShowLoader] = React.useState(false);
    const dispatch = useDispatch();
    const [reportListing, setReportListing] = useState([]);
    const [filterData, setfilterData] = useState({
        pageIndex: 1,
        pageSize: 30,
        sortColumn: '',
        sortOrder: 'DESCENDING',
        reportType: reportDetails.reportType,
    });

    useEffect(() => {
        fetchDisputedReport();
    }, [filterData.pageIndex, filterData.pageSize, filterData.sortColumn, filterData.sortOrder]);

    const fetchDisputedReport = async () => {
        setShowLoader(true);
        const { firstDate, lastDate } = getFirstAndLastDate(periodDetail.year, periodDetail.monthName);
        let payload = {
            ...filterData,
            isMultiple: true,
            startDate: moment(firstDate).format("YYYY-MM-DDT00:00:00"),
            endDate: moment(lastDate).format("YYYY-MM-DDT00:00:00")
        };
        const result = dispatch(getReconciliationTransactionDetails(payload));
        if (result) {
            result.then(res => {
                if (res.success) {
                    setShowLoader(false);
                    let dataList = res.data.entityList.map((item, index) => {
                        return {
                            ...item,
                            id: index + 1,
                            transactionAmount: `$ ${formatNumberWithCommas(item.transactionAmount)}`,
                            profit: `$ ${formatNumberWithCommas(item.profit)}`,
                            rate: `$ ${formatNumberWithCommas(item.rate)}`,
                            carrierAdminFee: `$ ${formatNumberWithCommas(item.carrierAdminFee)}`,
                            wmsAdminFee: `$ ${formatNumberWithCommas(item.wmsAdminFee)}`
                        };
                    });
                    setReportListing(dataList || []);
                    setfilterData({
                        ...filterData,
                        totalPages: Math.ceil(res.data.totalRecords / filterData.pageSize),
                        totalRecords: res.data.totalRecords
                    });
                    return;
                } else {
                    setShowLoader(false);
                    setReportListing([]);
                    toast.error(res.message || 'Failed to fetch disputed transactions');
                }
            });
        } else {
            setReportListing([]);
            setShowLoader(false);
            toast.error(result.message || 'Failed to fetch disputed transactions');
        }
    };

    const handleSortingColumn = (columnKey) => {
        let newSortOrder = filterData.sortOrder === "ASCENDING" ? "DESCENDING" : "ASCENDING";
        if (filterData.sortColumn === columnKey) {
            newSortOrder = filterData.sortOrder === 'ASCENDING' ? 'DESCENDING' : 'ASCENDING';
        }
        setfilterData({
            ...filterData,
            sortColumn: columnKey,
            sortOrder: newSortOrder,
            pageIndex: 1
        });
    };

    return (
        <Modal
            size="xl"
            show={show}
            onHide={handleCancel}
            centered
        >
            <div className="top_modal_header_container no_mrg">
                <div>
                    <span>Disputed Tracking Records - {periodDetail.month} {showLoader && <LoaderSpinner />}</span>
                </div>
                <div className="modalDeleteWrapper">
                    <button
                        type="button"
                        onClick={() => handleCancel()}
                        className="btn-close"
                        aria-label="Close"
                    ></button>
                </div>
            </div>
            <Modal.Body className='fontFix incomingTbl pt-0 tableFixHead'>
                {!showLoader && (
                    <CollapsibleTable
                        filterData={filterData}
                        columns={ReconciliationDisputedTransactionDetailsColumns}
                        data={reportListing}
                        handleSortingColumn={handleSortingColumn}
                    />
                )}
                {!showLoader && (
                    <BatchPagination
                        gridData={reportListing}
                        totalVisualRecords={reportListing.length}
                        numberOfPage={filterData.pageSize}
                        numOfPage={numOfPage}
                        loader={showLoader}
                        currentPage={filterData.pageIndex}
                        totalPages={filterData.totalPages}
                        totalRecords={filterData.totalRecords}
                        setCurrentPage={(value) => setfilterData({ ...filterData, pageIndex: value })}
                        setNumberOfPage={(value) => setfilterData({ ...filterData, pageSize: value, pageIndex: 1 })}
                    />
                )}
            </Modal.Body>
        </Modal>
    );
}

DisputedTransactions.propTypes = {
    show: PropTypes.bool,
    handleCancel: PropTypes.func,
    reportDetails: PropTypes.object,
    periodDetail: PropTypes.object
};
 
export default DisputedTransactions;